export const customizableEmailTemplates = {
  NewProfileRequest: { type: 2, name: 'New profile request' },
  NewProfileRequestReminder: { type: 5, name: 'New profile request reminder' },
  ProfileItemExpired: { type: 15, name: 'Profile item expired' },
  ProfileItemRejected: { type: 7, name: 'Profile item rejected' },
  ProfileRequestDeclined: { type: 37, name: 'Profile request declined' },
  ProfileRequestApproved: { type: 36, name: 'Profile request approved' },
  NewProfileRequestCancelled: { type: 13, name: 'New profile request cancelled' },
  Message: { type: 41, name: 'User message' },
  NewProfileRequestMeeting: { type: 48, name: 'New profile request meeting' },
  ProfileRequestMeetingReminder: { type: 50, name: 'Profile request meeting reminder' },
};
